<template>
   <div class="schedule-demo">
      <a class="schedule-demo-button" @click="showScheduleDemoPopup" @mousedown.prevent="preventMouseDown"> Subscribe! </a>
      <transition name="slide-fade">
         <div v-if="isDemoPopupVisible" id="container">
            <div id="popup" ref="popupEl">
               <img src="../../assets/dashx-close.png" class="close-icon pointer" @click="hideScheduleDemoPopup"></img>
               <h2>
                  Let's get started 🎈
               </h2>
               <div class="grey-out">
                  We secretly love coments too.
               </div>
               <div class="fields-list" :class="{ 'hide': submissionSuccess}">
                  <input class="form-field" placeholder="Username" v-model.trim="username" @input="$v.username.$touch()" :class="{ 'form-field-error': isFieldInvalid('username') }"></input>
                  <input class="form-field" placeholder="Email*" v-model.trim="email" @input="$v.email.$touch()" :class="{ 'form-field-error': isFieldInvalid('email') }"></input>
               </div>
               <div class="success-icon-refpoint" :class="{ 'hide': !submissionSuccess }">
                     <transition name="slide-fade">
                        <img v-if="submitted" class="success-icon" src="../../assets/circled_checkmark.svg"></img>
                     </transition>
               </div>
               <div class="submit-row">
                  <a v-if="submissionState('button')" tabIndex="0" class="submit-button" :disabled="isFormInvalid()" @click="submitForm" @mousedown.prevent="preventMouseDown">
                     Submit
                  </a>
                  <rtx-spinner v-if="submissionState('spinner')"></rtx-spinner>
                  <div v-if="submissionState('response')"> {{ response }} <a v-if="!submissionSuccess" class="resubmit" @click="submitForm"> Resubmit </a> </div>
               </div>
            </div>
         </div>
      </transition>
   </div>
</template>

<script>
import { required, minLength, maxLength, between, email } from 'vuelidate/lib/validators';
import { requestDemo } from '../../backend/site.js';

// Initial data object
function initialData() {
   return {
      username: '',
      email: '',
      submitted: false,
      response: '',
      popupVisible: false,
      submissionSuccess: false,
      popupOpenedAtScreenWidth: 0,
      popupOpenedAtScreenHeight: 0
   }
}

export default {
   name: 'ScheduleDemo',
   data: initialData,
   computed: {
      isDemoPopupVisible() {
         return this.popupVisible;
      }
   },
   methods: {
      preventMouseDown: (e) => {},
      showScheduleDemoPopup: function () {
         this.popupOpenedAtScreenWidth = window.innerWidth;
         this.popupOpenedAtScreenHeight = window.innerHeight;
         this.popupVisible = true;
         this.scrollToDemoElement();
      },
      hideScheduleDemoPopup: function () {
         Object.assign(this.$data, initialData());
         this.$v.$reset(); // Reset validation
      },
      submitForm: function() {
         if ( !this.isFormInvalid() ) {
            var formData = this._.pick(this.$data, ['username', 'email']);
            this.submitted = true;

            requestDemo(formData)
            .then(result => {
               var data = result.data;
               if (data.status === 'success') {
                  this.submissionSuccess = true;
                  this.response = data.message;
               } else {
                  this.response = data.message;
               }
            })
            .catch(error => {
               this.response = 'Failed to submit request.';
            });
         }
      },
      isFieldInvalid(fieldName) {
         return this.$v[fieldName].$invalid && this.$v[fieldName].$dirty;
      },
      isFormInvalid() {
         return this.$v.$invalid;
      },
      submissionState(viewItem) {
         if (viewItem === 'button') {
            if (!this.submitted) return true;
         };
         if (viewItem === 'spinner') {
            if (this.submitted && !this.response) return true;
         };
         if (viewItem === 'response') {
            if (this.submitted && this.response) return true;
         };
      },
      scrollToDemoElement () {
         // The hidden element won't be available right away, try next tick
         this.$nextTick( function () {
            if (window.innerHeight <= 520) {
               this.$scrollTo(this.$refs.popupEl);
            } else {
               if (window.innerWidth <= 680) { // Same as responsive UI max-width
                  this.$scrollTo(this.$el);
               }
            }
         });
      },
      scrollToDemoOnResize() {
         if (this.isDemoPopupVisible) {
            if (window.innerHeight <= 520) {
               this.$refs.popupEl.scrollIntoView();
            } else {
               if (window.innerWidth <= 680) { // Same as responsive UI max-width
                  this.$el.scrollIntoView();
               }
            }
         }
      }
   },
   created: function() {
      window.addEventListener('resize', this.scrollToDemoOnResize);
   },
   destroyed: function() {
      window.removeEventListener('resize', this.scrollToDemoOnResize);
   },
   validations: {
      username: { minLength: minLength(2), maxLength: maxLength(64) },
      email: { required, email, maxLength: maxLength(256) }
   }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.schedule-demo {
   padding: 3rem 0rem 6rem 0rem;
  display: flex;  
}

#container {
   width: 100%;
   height: 140%;
   top: 0;
   left: 0;
   position: absolute;
   display: block;
   background-color: rgba(229,228,226, 0.7); /* COLOR PLATINUM HTML Code #e5e4e2 */
}

#popup {
   position: relative;
   margin: 0 auto;
   top: 20vh;
   min-height: 420px;
   background-color: #fefefe;
   width: 560px;
   box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
   padding: 1em;
   z-index: 1;
   border: solid 1px;
   border-color: #e8e8e8;
   text-align: center;
}

.schedule-demo-button {
   display: block;
   width: 12em;
   text-align: center;
   margin: auto;
   font-size: 1.2em;
   cursor: pointer;
}

.form-field {
   width: 24em;
   margin: 1em;
   padding: 0.25em 0.5em 0.2em 0.5em;
   border-width: 1px;
   border-style: solid;
   border-color: #DDDDDD; /* COLOR GREY TEXT INPUT BOX */
   -webkit-box-sizing: border-box;
   -moz-box-sizing: border-box;
   box-sizing: border-box;
   border-top: none;
   border-left: none;
   border-right: none;
   font-size: 0.9em;
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
}

.form-field-error {
   outline: none; /* COLOR GREY TEXT INPUT BOX */
   border-color: #BA0D61;
   box-shadow: 0 0 10px #BA0D61;
   border-bottom: none;
}

.fields-list {
   width: 24rem;
   margin: 4em auto;
}

.close-icon {
   width: 24px;
   height: 24px;
   margin-left: 95%;
   opacity: 0.48;
}

.success-icon-refpoint {
   position: relative;
   top: -11rem;
   height: 0px;
   text-align: center;
}
.success-icon {
   width: 8rem;
}

/* + Submit form */
.submit-button {
   display: block;
   width: 6em;
   font-size: 1rem;
   text-align: center;
   padding: 0.4em 0.8em;
   padding-top: 0.42rem;   
   border-color: black;
   border: solid 1px;
   border-radius: 4px;
   border-width: 2px;
   cursor: pointer;
}

.submit-button:hover {
   color: white;
   background: #BA0D61; /* COLOR - FOCUS MAROON */
   border-color: #BA0D61;
   border-radius: 6px;
}

.submit-button:focus {
   color: white;
   background: #BA0D61; /* COLOR - FOCUS MAROON */
   border-color: #BA0D61;
   border-radius: 6px;
}

.submit-button[disabled], .submit-button[disabled]:hover, .submit-button[disabled]:focus {
   cursor: default;
   color: #777777; /* COLOR GREY OUT  */
   background: white;
   border-color: #CCCCCC; /* COLOR DISABLED GREY BORDER */ 
}

.submit-row {
   display: flex;
   height: 4rem;
   justify-content: center;
   align-items: center;
   margin: 1.6em 0em;
}

.resubmit {
   display: inline-block;
   text-decoration: underline;
   cursor: pointer;
}
/* - Submit form */

/* + Animation */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
/* - Animation */

/* + Responsive UI */
@media screen and (max-height: 680px) { 
   #popup {
      top: 10vh;
   }
}

@media screen and (max-width: 680px), screen and (max-height: 520px) { 
   /* When form is open in this screen size, hide the containing button row in JS code */
   #container {
      position: static;
      background-color: transparent;
   }

   #popup {
      position: static;
      min-height: 380px;
      width: auto;
      box-shadow: none;
      border: none;
      margin-top: 3rem;
      border-top: solid 1px;
      border-color: gray;
      margin-bottom: -3rem;
      background: transparent;
   }

   .form-field {
      width: 20rem;
      font-size: 1rem;
   }
}

@media screen and (max-width: 480px) {
   .form-field {
      margin-left: -1px;
      width: 18rem;
   }

   .fields-list {
      width: 18rem;
   }
}
/* - Responsive UI */

</style>



// WEBPACK FOOTER //
// src/components/site/ScheduleDemo.vue